import { Form } from "../components"
import TradeCards from "./components/TradeCards"
import TradeConvert from "./components/TradeConvert"
import TradeEmbrace from "./components/TradeEmbrace"
import TradeHero from "./components/TradeHero"

export default function TradingPlatforms() {
  return (
    <>
      <section>
        <TradeHero />
        <TradeCards />
        <TradeConvert />
        <TradeEmbrace />

        <div className="bg-blue py-10 px-5 lg:py-20 2xl:px-0">
          <article className="xl:max-w-6xl xl:mx-auto">
            <h2 className="text-white text-3xl lg:text-5xl mb-5 lg:mb-10 lg:leading-snug">
              Need more information about our
              <span className="block">offers? Let us contact you today!</span>
            </h2>
            <Form />
          </article>
        </div>
      </section>
    </>
  )
}
